















import { Component, Vue, Prop, PropSync, Watch, Emit } from 'vue-property-decorator';
import CourseCell from '@/components/courseCell/courseCell.vue';
import draggable from 'vuedraggable'
import { updateCourseSortBat} from '@/apis/courseList/courseList';
@Component({
  components: {
    CourseCell,
    draggable,
  },
})
export default class SortList extends Vue {
  @PropSync('listData', { type: Object, default: {} }) sortList!: any;
  
  created(): void {
    
  }
  endEvent(evt:any){
  let courseidlist: string = ''
  let list = this.sortList.list
  list.forEach((item: any) => {
      if (courseidlist) {
        courseidlist += `|${item.id}`
      } else {
        courseidlist = item.id as string
      }
    })
  updateCourseSortBat({courseidlist:courseidlist})
  }
}
